import React from 'react'
import SuccessScreen from '../../Common/SuccessScreen';


const PaymentSuccess = () => {
    return (
        <SuccessScreen
            title="Successful!"
            subtitle={`Your payment is successfull`}
        />
    )
}

export default PaymentSuccess